class BackToTopButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.threshold = parseInt(this.dataset.threshold, 10) || 400;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);

    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      const shouldShow = window.scrollY > this.threshold;
      this.button.classList.toggle('back-to-top--visible', shouldShow);
      this.ticking = false;
    });
  }

  onClick() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
    });

    const mainContent = document.getElementById('MainContent');
    if (mainContent) {
      mainContent.focus({ preventScroll: true });
    }
  }
}

customElements.define('back-to-top-button', BackToTopButton);
